import { Trans, useTranslation } from 'react-i18next';

import { Icon, Tooltip } from '~/components';

// @TODO WMG1-660 - Implement Budget Distribution component.
export function BudgetDistribution() {
  const { t } = useTranslation('campaign-planner');

  return (
    <div className="space-y-md rounded-sm p-lg bg-emphasis-default">
      <div className="text-headline-md font-semibold">
        {t('digitalCampaigns.mediaPlan.budgetDistribution.label')}
        <span className="ml-xs">
          <Tooltip
            content={
              <Trans
                t={t}
                i18nKey="digitalCampaigns.mediaPlan.budgetDistribution.tooltip"
                components={{ strong: <span className="font-bold" /> }}
              />
            }
          >
            <Icon type="circle-info" variant="light" size="2xs" />
          </Tooltip>
        </span>
      </div>
    </div>
  );
}

BudgetDistribution.displayName = 'BudgetDistribution';
